import PropTypes from 'prop-types';

import './styles/headingContentStyles.css';

// NOTE: This component should be deprecated in favor of the refactored <Header> component.
//       Components to only add CSS classes are discouraged unless absolutely necessary.
const HeadingContent = ({ children, ...rest }) => (
  <div
    className="flex flex-row items-start justify-between heading-content-margin"
    {...rest}
  >
    {children}
  </div>
);

HeadingContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeadingContent;
